import React, { useEffect, useState } from 'react';
import FloatingMortar from '../components/common/FloatingMortar';
import lotusimg from '../assets/lotus.png';

const FloatingMortarButton = () => {
  const [rotation, setRotation] = useState({ x: 0, y: 0 });
  const [parallax, setParallax] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      const range = 40;
      const calcValue = (a, b) => (a / b * range - range / 2).toFixed(1);

      const yValue = calcValue(e.clientY, window.innerHeight);
      const xValue = calcValue(e.clientX, window.innerWidth);

      // Rotation for mortar
      setRotation({ x: yValue, y: xValue });

      // Translation for lotus (parallax effect)
      setParallax({ x: xValue * 0.5, y: yValue * 0.5 });
    };

    document.addEventListener("mousemove", handleMouseMove);
    return () => document.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <>
      {/* Lotus Image with Parallax Translation */}
      <div
        className="fixed left-4 bottom-1 z-[9999] w-[20%] h-[20%] ab:bottom-[0%] lg:bottom-[0%] xl2:w-32 xl2:h-32 xl2:bottom-[0%] ab:w-32 ab:h-32 tb:bottom-[-3%] transition flex items-center justify-center"
        aria-label="Lotus image"
        style={{
          cursor: 'pointer',
          background: 'transparent',
        }}
      >
        <img
          src={lotusimg}
          alt="Lotus"
          style={{
            transform: `translateX(${parallax.x}px) translateY(${parallax.y}px)`,
            transition: 'transform 0.1s ease-out',
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </div>

      {/* Floating Mortar with Rotation */}
      <div
        className="fixed xl2:right-[10%] xl2:bottom-16 bottom-[9%] z-[9999] w-20 h-20 sm:w-32 sm:h-32 ab:w-32 ab:h-32 right-[15%] tb:scale-100 tb:bottom-[6%] tb:right-[12%] lg:bottom-[7%] ab:bottom-[4%] transition flex items-center justify-center"
        aria-label="Floating mortar"
        style={{
          cursor: 'pointer',
          background: 'transparent',
        }}
      >
        <div
          style={{
            transform: `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`,
            transformStyle: 'preserve-3d',
            transition: 'transform 0.1s ease-out',
            width: '100%',
            height: '100%',
            scale: '0.7',
          }}
        >
          <FloatingMortar />
        </div>
      </div>
    </>
  );
};
export default FloatingMortarButton;